import { posKey } from '../../utills/meal-planer';

export const selectPositionById = (state, id) => {
    return state.mealPlaner.positions[posKey(id)];
};

export const selectSuggestions = (state) => state.mealPlaner.suggestions ?? [];

export const selectSuggestionsStatus = (state) => state.mealPlaner.suggestionsStatus ?? 'idle';

export const selectIngredientSwap = (state) =>
    state.mealPlaner.ingredientSwap ?? {
        ingredient: null,
        proposals: [],
        report: null,
        status: 'idle',
    };

export const selectPositionIdsByRecipeOrMeal = (state, { positionId, recipeId, mealId }) => {
    const positions = Object.values(state.mealPlaner.positions ?? {});
    const positionIds = positions
        .filter((position) => {
            if (recipeId) return position.recipeId === recipeId;
            if (mealId) return position.mealId === mealId;
            return position.positionId === positionId;
        })
        .map((position) => position.positionId);
    return positionIds.includes(positionId) ? positionIds : [positionId, ...positionIds];
};
